import actions, { setAssessment, setQualification } from './actions';
import { QualificationsActionTypes } from './types';
import { getAssessmentVersionsResponse, getQualificationsResponse } from '../../service/qualifications';
import { displayNotification } from '../notification/actions';
import { NotificationActionTypes } from '../notification/types';
import { Qualification } from '../../types/Qualifications';
import { deleteAllComponents } from '../components/actions';
import { ComponentsActionTypes } from '../components/types';
import { ThunkDispatch } from 'redux-thunk';
import { RootState } from '../index';

type Dispatch = ThunkDispatch<
  RootState,
  never,
  QualificationsActionTypes | NotificationActionTypes | ComponentsActionTypes
>;

export const getQualificationData =
  (businessUnit: string) =>
  async (dispatch: Dispatch): Promise<void> => {
    try {
      dispatch(actions.getQualifications());
      const requestData = await getQualificationsResponse(businessUnit);
      dispatch(actions.setQualifications(requestData));
    } catch (err) {
      dispatch(actions.setError());
      dispatch(displayNotification('Failed to get qualifications data'));
    }
  };

export const setQualificationAndAssessment =
  (qualification: Qualification) =>
  (dispatch: Dispatch): void => {
    dispatch(setAssessment(undefined));
    dispatch(deleteAllComponents());

    dispatch(setQualification(qualification));

    if (qualification.assessments.length === 1) {
      void dispatch(
        getAssessmentVersions(qualification.businessUnit.id, qualification.id, qualification.assessments[0].code),
      );
    }
  };

export const getAssessmentVersions =
  (businessUnit: string, qualificationId: number, assessmentCode: string) =>
  async (dispatch: Dispatch): Promise<void> => {
    try {
      dispatch(actions.getAssessmentVersions());
      dispatch(actions.setAssessmentVersions(undefined));
      const requestData = await getAssessmentVersionsResponse(businessUnit, qualificationId, assessmentCode);

      const sortedAssessment = [...requestData].sort((first, second) => first.version - second.version);
      dispatch(actions.setAssessmentVersions(sortedAssessment));
    } catch {
      dispatch(actions.setError());
      dispatch(displayNotification('Failed to get assessment versions'));
    }
  };

export default { getQualificationData, setQualificationAndAssessment, getAssessmentVersions };
